<section >
  <header>

    <p class="date-today">{{months[viewMonth - 1]}}, {{ viewYear }}</p>

    <div>
      <img (click)="previousMonth()" src="/calender/prev-icon.svg" alt="">
      <img (click)="nextMonth()" src="/calender/next-icon.svg" alt="">
    </div>
  </header>


  <div class="calender">
    <ul class="week">
      <li>Sun</li>
      <li>Mon</li>
      <li>Tues</li>
      <li>Wed</li>
      <li>Thu</li>
      <li>Fri</li>
      <li>Sat</li>
    </ul>

    <ul class="days">

      @for (cell of days; track $index) {
        <li
          class="text"
          [class.attendanceDay]="cell.leaveDay"
          [class.present]="cell.inRange && !cell.isWeekend && cell.status === 'PRESENT'"
          [class.absent]="cell.inRange && !cell.isWeekend && cell.status === 'ABSENT'"
          [class.no-record]="cell.inRange && !cell.isWeekend && !cell.status"
          [class.range-out]="!cell.inRange || cell.isWeekend">
          <p [class.date-today]="cell.isToday" class="dot"></p>
          <p>{{ cell.day }}</p>
        </li>
      }
    </ul>
  </div>

</section>
